/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

orderConfirmationAccountSignUpMessageStyles.container = {
    css: css`
        display: flex;
        margin-bottom: 25px;
        align-items: center;
        ${screen("lte", "xs")} {
            flex-wrap: wrap;
        }
    `,
};

orderConfirmationAccountSignUpMessageStyles.createAccountText = {
    variant: "p",
    css: css`
        margin-bottom: 0;
        margin-right: 20px;
    `,
};

orderConfirmationAccountSignUpMessageStyles.createAccountButton = {
    css: css`
        margin-left: auto;
        ${screen("lte", "xs")} {
            flex: 1 1 100%;
            margin-top: 20px;
        }
    `,
};
